import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmergencyContactRow, EmergencyContactSearchFields } from "models/emergency-contact";

export interface EmergencyContactsSliceState {
    emergencyContacts: EmergencyContactRow[],
    divisions: string[],
    departments: string[],
    provinces: string[]
}

export const initialState: EmergencyContactsSliceState = {
    emergencyContacts: [],
    divisions: [],
    departments: [],
    provinces: []
};

const EmergencyContactsSlice = createSlice({
    name: "emergencyContacts-slice",
    initialState,
    reducers: {
        setEmergencyContacts(state, { payload }: PayloadAction<EmergencyContactRow[]>) {
            state.emergencyContacts = payload
        },
        setEmergencyContactSearchFields(state, { payload }: PayloadAction<EmergencyContactSearchFields>) {
            state.divisions = payload.divisions;
            state.departments = payload.departments;
            state.provinces = payload.provinces;
        }
    },
});

export const {
    setEmergencyContacts,
    setEmergencyContactSearchFields
} = EmergencyContactsSlice.actions

export default EmergencyContactsSlice.reducer;
